module.exports = __webpack_public_path__ + "img/7.aab3be87.png";